import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { PROP_TYPES } from 'constants';
import {
    addUserMessage,
    emitUserMessage,
    setButtons,
    toggleInputDisabled,
    navigate,
    emitWidgetEvent,
    emitApplicationEvent,
} from 'actions';
import Message from '../Message/index';
import { APPLICATION_EVENT } from '../../../../../../../../application-events';
import ButtonPostback from './components/ButtonPostback';
import ButtonInternalLink from './components/ButtonInternalLink';
import ButtonExternalLink from './components/ButtonExternalLink';

import './styles.scss';
import ThemeContext from '../../../../../../ThemeContext';

class Buttons extends PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);

        const { message, getChosenReply, inputState, id } = this.props;

        const hint = message.get('hint');
        const chosenReply = getChosenReply(id);
        if (!chosenReply && !inputState) {
            // this.props.toggleInputDisabled();
        }
    }

    handleClick(reply) {
        const { chooseReply, id } = this.props;

        const payload = reply.get('payload');
        const title = reply.get('title');
        chooseReply((payload && payload.toJS && payload.toJS()) || payload, title, id);
    }

    handleNavigation(reply) {
        const { navigate, id } = this.props;

        const payload = reply.get('payload');
        const title = reply.get('title');
        navigate((payload && payload.toJS && payload.toJS()) || payload, title, id);
    }

    handleButtonClickEvent(reply) {
        const { dispatchWidgetEvent, dispatchApplicationEvent, id } = this.props;

        dispatchApplicationEvent(
            APPLICATION_EVENT.BUTTON_CLICK,
            (reply && reply.toJS && reply.toJS()) || reply,
            id
        );
        dispatchWidgetEvent('onButtonClick', (reply && reply.toJS && reply.toJS()) || reply, id);
    }

    renderButtons(message, buttons, chosenReply) {
        const { isLast, linkTarget, separateButtons } = this.props;
        const { userTextColor, userBackgroundColor } = this.context;
        const buttonStyle =
            userTextColor || userBackgroundColor
                ? {
                      color: userTextColor,
                      backgroundColor: userBackgroundColor,
                      borderColor: userBackgroundColor,
                  }
                : undefined;
        return (
            <div className="rw-replies-content">
                {separateButtons && <div className="rw-separator" />}
                {
                    <div className="rw-replies">
                        {buttons.map((reply, index) => {
                            if (reply.get('type') === 'web_url_internal') {
                                return (
                                    <ButtonInternalLink
                                        key={index}
                                        variant={reply.get('variant')}
                                        style={buttonStyle}
                                        onClick={(e) => {
                                            this.handleButtonClickEvent(reply);
                                            this.handleNavigation(reply);
                                        }}
                                    >
                                        {reply.get('title')}
                                    </ButtonInternalLink>
                                );
                            }
                            if (reply.get('type') === 'web_url') {
                                return (
                                    <ButtonExternalLink
                                        key={index}
                                        href={reply.get('url')}
                                        target={linkTarget || '_blank'}
                                        variant={reply.get('variant')}
                                        style={buttonStyle}
                                        onClick={(e) => {
                                            this.handleButtonClickEvent(reply);
                                        }}
                                    >
                                        {reply.get('title')}
                                    </ButtonExternalLink>
                                );
                            }
                            // assume 'postback' button type as default:
                            return !chosenReply ? (
                                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                                <ButtonPostback
                                    key={index}
                                    variant={reply.get('variant')}
                                    style={buttonStyle}
                                    onClick={(e) => {
                                        this.handleButtonClickEvent(reply);
                                        this.handleClick(reply);
                                    }}
                                >
                                    {reply.get('title')}
                                </ButtonPostback>
                            ) : undefined;
                        })}
                    </div>
                }
            </div>
        );
    }

    render() {
        const { message, getChosenReply, id } = this.props;

        const buttons = message.get('buttons') || message.get('quick_replies');

        return (
            <>
                <Message message={message} />
                {buttons !== undefined && this.renderButtons(message, buttons, getChosenReply(id))}
            </>
        );
    }
}

Buttons.contextType = ThemeContext;

const mapStateToProps = (state) => ({
    getChosenReply: (id) => state.messages.get(id).get('chosenReply'),
    inputState: state.behavior.get('disabledInput'),
    linkTarget: state.metadata.get('linkTarget'),
});

const mapDispatchToProps = (dispatch) => ({
    toggleInputDisabled: () => dispatch(toggleInputDisabled()),
    chooseReply: (payload, title, id) => {
        dispatch(setButtons(id, title));
        dispatch(addUserMessage(title));
        dispatch(emitUserMessage(payload, 'button'));
        // dispatch(toggleInputDisabled());
    },
    navigate: (payload, title, id) => {
        dispatch(navigate(payload));
    },
    dispatchWidgetEvent: (event, payload, id) => {
        dispatch(emitWidgetEvent(event, payload));
    },
    dispatchApplicationEvent: (event, payload, id) => {
        dispatch(emitApplicationEvent(event, payload));
    },
});

Buttons.propTypes = {
    getChosenReply: PropTypes.func,
    chooseReply: PropTypes.func,
    navigate: PropTypes.func,
    dispatchWidgetEvent: PropTypes.func,
    dispatchApplicationEvent: PropTypes.func,
    id: PropTypes.number,
    isLast: PropTypes.bool,
    message: PROP_TYPES.BUTTONS,
    linkTarget: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(Buttons);
